// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmGlobal = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('#body'),
			bodyRestrain: 'body-restrain',
			$header: $('#header'),
			$headerSearch: $('#headerSearch, #closeSearch'),
			active: 'header--active',
			$search: $('.header__search'),
			searchActive: 'header__search--active',
			searchField: '.header__search-field',
			scrolled: 'header--scrolled',
			mobileMenu: '#menu',
			$window: $('window'),
			activeSticky: false,
			searchFocus: false,
			close: ".notification-bar__cookie-accept",
			coronaclose: ".corona-bar__accept",
			bar: ".notification-bar",
			coronabar: ".corona-bar",
			$cookieBar: $("#cookieBar"),
			cookieClass: "notification-bar-wrap--cookie",
			mapSearchRadius: 0.2
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.country = settings.$body.data('country');
		}

		// Toggle Active Classes
		methods.toggle = function () {
			settings.$header.toggleClass(settings.active);
			settings.$body.toggleClass(settings.bodyRestrain);
		}

		// Toggle Active Classes
		methods.toggleScroll = function () {
			settings.activeSticky ^= true;
			settings.$header.toggleClass(settings.scrolled);
		}

		methods.searchFocus = function () {
			if(settings.searchFocus) {
				settings.$search.toggleClass(settings.searchActive).find(settings.searchField).blur();
			} else {
				settings.$search.toggleClass(settings.searchActive).find(settings.searchField).focus();
			}
			settings.searchFocus ^= true;
		}

		methods.setCookie = function (cookieName, cookieValue) {
			var oDate = new Date();
			oDate.setYear(oDate.getFullYear() + 1);
			var sCookie = encodeURIComponent(cookieName) + '=' + encodeURIComponent(cookieValue) + ';expires=' + oDate.toGMTString() + ';path=/';
			document.cookie = sCookie;
		};

		methods.getCookie = function (cookieName) {
			cookieName = cookieName.toLowerCase();
			var oCrumbles = document.cookie.split(';');
			for (var i = 0; i < oCrumbles.length; i++) {
				var oPair = oCrumbles[i].split('=');
				var sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
				var cookieValue = oPair.length > 1 ? oPair[1] : '';
				if (sKey == cookieName) {
					return decodeURIComponent(cookieValue);
				}
			}
			return '';
		},

		// Bind events
		methods.events = function($context) {
			// Mobile Menu button click toggles the class
			$(settings.mobileMenu).off('click.lmGlobal').on('click.lmGlobal', function (event) {
				event.preventDefault();
				methods.toggle();
			});

			// Form submit function
			settings.$search.off('submit.lmGlobal').on('submit.lmGlobal', function(event) {
				event.preventDefault();

				// Setting to false so can run normal post search functions
				settings.searchValue = settings.$search.find(settings.searchField).val();
				settings.countryValue = '';
				$.fn.lmGlobal.ajaxCheck(settings);
			});

			// Scroll detection to add class to header.
			$(window).off('scroll.lmGlobal').on('scroll.lmGlobal', function () {
				if ( ($(this).scrollTop() > 50 && !settings.activeSticky) || ($(this).scrollTop() <= 50 && settings.activeSticky) ) {
					methods.toggleScroll();
				}
			});

			settings.$headerSearch.off('click.lmGlobal').on('click.lmGlobal', function (event) {
				event.preventDefault();
				methods.searchFocus();
			});

			// Close button click
			$(document).on('click', settings.close, function(e) {
				var _this = this;

				$(this).closest(settings.bar).addClass("notification-bar__removed");

				$(_this).closest(settings.bar).fadeOut(400);

				methods.setCookie("cookiePolicy", "accepted");
			});
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);
			$.fn.lmGlobal.checkPlatform(settings);

			if (!methods.getCookie('cookiePolicy')) {
				settings.$cookieBar.addClass(settings.cookieClass);
			}
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	// Define our format function.
	$.fn.lmGlobal.searchSubmit = function(settings) {
		var result = settings.locationResults[0];

		if (settings.countryValue) {
			settings.searchUrl = settings.domain + settings.countryValue;
		} else {
			settings.searchUrl = settings.domain + settings.country + '/' + $('body').data('searchstring') + '/';
		}

		window.location.replace(settings.searchUrl + '?value=' + settings.searchValue);
	};

	$.fn.lmGlobal.ajaxCheck = function(settings) {

		// Check cache
		if (!settings.dataSnapShot) {

			$.ajax({
				type: 'GET',
				dataType: 'json',
				url: settings.locationJsonUrl,
				success: function(data, textStatus, jqXHR) {
					settings.mapMarkers = data.Markers;
					settings.mapMessages = data.Messages;
					settings.dataSnapShot = defiant.getSnapshot(data);
					$.fn.lmGlobal.searchJson(settings);
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					// TODO error handling
				}
			});
		} else {
			// Cache
			$.fn.lmGlobal.searchJson(settings);
		}
	}

	$.fn.lmGlobal.searchJson = function(settings) {

		// Search IMO JSON address node based on user input
		settings.locationResults = defiant.json.search(settings.dataSnapShot, "//*[contains(Address, '"+ settings.searchValue +"') and contains(Country, '"+ settings.countryValue +"')]");

		// If no result. Query google maps geocoding API.
		if (settings.locationResults.length == 0) {
			$.fn.lmGlobal.searchMapApi(settings);
		} else {
			$.fn.lmGlobal.searchSubmit(settings);
		}
	}

	// Fallback fuction when result from internal IMO JSON is not found. Uses google geocoding to find a lat and long based on what user is typing.
	// TODO. Url below on ajax call needs changing to internal BED handler Url when they've done it.
	// Needs to be BED driven as google geocoding API needs to be locked to one IP (server IP) and also has a low limit of calls allowed for free so cannot be showing API key in console.
	$.fn.lmGlobal.searchMapApi = function(settings) {
		var searchValue = settings.searchValue.trim().replace(' ', '+'),
				addressString = '';

		var countryValue = settings.country;

		countryValue ? addressString = searchValue + '+' + countryValue : addressString = searchValue;

		var	data = {
			address: addressString,
			country: countryValue
		}

		$.ajax({
			type: 'GET',
			dataType: 'json',
			data: data,
			url: settings.googleGeoCodeUrl,
			success: function(data, textStatus, jqXHR) {
				if (data.results[0]) {

					// Finding lat and long from search result from google geocoding API. Then creating a radius to search.
					var latArea = data.results[0].geometry.location.lat,
							lngArea = data.results[0].geometry.location.lng,
							latLowRange = latArea - settings.mapSearchRadius,
							latHighRange = latArea + settings.mapSearchRadius,
							lngLowRange = lngArea - settings.mapSearchRadius,
							lngHighRange = lngArea + settings.mapSearchRadius;

					// Searching the JSON for a radius.
					settings.locationResults = defiant.json.search(settings.dataSnapShot, "//*[Latitude > " + latLowRange + " and Latitude < " + latHighRange + " and Longitude > " + lngLowRange + " and Longitude < " + lngHighRange +"]");

					// If predictive search load predictive panel. Else submit form.
					$.fn.lmGlobal.searchSubmit(settings);
				}
			},
		});
	}

	$.fn.lmGlobal.checkIP = function(ip) {
		var r = RegExp('^http[s]?:\/\/((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])');
		return r.test( ip );
	}

	$.fn.lmGlobal.checkPlatform = function(settings) {
		var url = window.location.href,
				url = url.split("/"),
				reDirectUrl = url[0] + "//" + url[2] + '/';

		// Set global domain var
		settings.domain = reDirectUrl;
		settings.locationJsonUrl = settings.domain + 'umbraco/api/location/get';
		settings.googleGeoCodeUrl = settings.domain + 'umbraco/api/geo/get';
		settings.locationUrl = '/' + $('body').data('locationstring');
		settings.searchUrl = settings.domain + settings.country + '/' + $('body').data('searchstring') + '/';
	}

	// Attach and run code
	$('html').lmGlobal();

}(jQuery));
